import { createContext, useState, useEffect, useContext } from 'react';
import { UserContext } from '../user/UserContext';
import { request } from '../../lib/requestHelper';

export const StripeContext = createContext();

export function StripeProvider({ children }) {
  const { user, loggedIn } = useContext(UserContext);
  const [stripeStatus, setStripeStatus] = useState({
    connected: false,
    payoutsEnabled: false,
    chargesEnabled: false,
    loading: false,
  });

  const fetchStripeStatus = async () => {
    if (!loggedIn || user?.active_role !== 'artisan') return;

    setStripeStatus((prev) => ({ ...prev, loading: true }));
    try {
      const status = await request("api/stripe/get-stripe-status", { method: "GET" });
      setStripeStatus({ ...status, loading: false });
    } catch (err) {
      console.error('Failed to fetch stripe status:', err);
      setStripeStatus((prev) => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    fetchStripeStatus();
  }, [loggedIn, user?.active_role]);

  return (
    <StripeContext.Provider value={{ stripeStatus, setStripeStatus, fetchStripeStatus }}>
      {children}
    </StripeContext.Provider>
  );
}
